module.exports = __webpack_public_path__ + "static/media/spenser-leighton-vhs.041a4b26.svg";